import { getTranslation, i18next, resolveTranslationLanguage } from "@mivo/i18n";
import { resolveMarketingUrl } from "@mivo/ui/resolveMarketingUrl";
import { useEffect } from "react";

import { MARKETING_LEGAL_REDIRECT_TRANSLATIONS } from "./constants";

type MarketingLegalRedirectProps = {
  path: "/termos" | "/privacidade";
};

/** Client-side fallback until edge 301 (BR-27) is live on app host. */
export default function MarketingLegalRedirect({ path }: MarketingLegalRedirectProps) {
  useEffect(() => {
    const locale = resolveTranslationLanguage(i18next.language);
    window.location.replace(resolveMarketingUrl(path, locale));
  }, [path]);

  return (
    <div className="min-h-[40vh] flex items-center justify-center p-10 text-muted-foreground/80 text-sm">
      {getTranslation(MARKETING_LEGAL_REDIRECT_TRANSLATIONS.redirecting)}
    </div>
  );
}
